import * as React from "react";

const SvgOpenNew = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="currentColor"
    viewBox="0 0 24 24"
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M2.588 19.413Q3.175 20 4 20h16q.824 0 1.413-.587Q22 18.825 22 18v-5h-2v5H4V6h5.175l2 2H13V6h-1l-2-2H4q-.824 0-1.412.588A1.93 1.93 0 0 0 2 6v12q0 .824.587 1.413"
      clipRule="evenodd"
    />
    <path fill="currentColor" d="m9.3 14.3 1.4 1.4L20 6.4V10h2V3h-7v2h3.6z" />
  </svg>
);
export default SvgOpenNew;
